namespace TabAurous {
    export interface APIImportRequest extends Serenity.ServiceRequest {
        VouchersCompleted?: string[];
        VoucherswithIssues?: TabAurous.Common.VoucherWithIssues[];
    }
}
